<template>
    <div class="answers_block" >
        <b-overlay :show="is_load">

            <b-row>
                <b-col>
                    <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="select_group">
                        <span  class="fal  fa-eject mr-1"></span>
                        {{__t('SELECT_GROUP')}}
                    </button>
                </b-col>

                <b-col>
                    <button class="btn btn-md btn-block btn-outline-success waves-effect waves-themed" v-on:click="add_group">
                        <span  class="fal  fa-eject mr-1"></span>
                        {{__t('ADD_GROUP')}}
                    </button>
                </b-col>

            </b-row>

            <div class="modofication_items mt-3" v-if="this.items.length > 0">
                <div class="row">
                    <div class="col-lg-6 col-sm-6 col-xl-6 border-right">
                        <h3>
                            <span class="badge badge-danger">
                                {{__t('REQUIRED')}}
                            </span>
                        </h3>
                        <product_group_new @remove_group="remove_group" v-for="group in this.req_group" :key="group.id" :item="group"></product_group_new>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-xl-6 border-right">
                        <h3>
                            <span class="badge badge-danger">
                                {{__t('NOT_REQUIRED')}}
                            </span>
                        </h3>
                        <product_group_new @remove_group="remove_group"  v-for="group in this.not_req_group" :key="group.id" :item="group"></product_group_new>
                    </div>

                </div>
            </div>
        </b-overlay>

        <group_choose></group_choose>
        <group_modal @on_group_finish="new_group_created"></group_modal>
    </div>
</template>

<script>
    import product_group_new from "../product_group_new";
    import Group_choose from "../../../modifiers/groups/choose/group_choose.vue";
    import group_modal from "../../../modifiers/groups/group_modal.vue";
    export default {
        name: "product_custom_modification",
        components : {
            group_modal,
            Group_choose,
            product_group_new,
        },
        props : {
            product : {
                type : Object
            }
        },
        created () {
            this.load_modifications();
            EventBus.$on('selected_groups',this.operate_group_list_event)
        },

        beforeDestroy() {
            EventBus.$off('selected_groups', this.operate_group_list_event);
        },

        data() {
            return {
                items: [],
                is_load: true,
            }
        },
        methods : {

            new_group_created(type,params) {
                console.log('group_saved',type,params);
                if(type == 'save') {
                    //Operate by ext_params
                    if(params.hasOwnProperty('ext_params')) {
                        let groups_push = [params.ext_params];
                        this.save_modifications(groups_push);
                    }
                }
            },

            operate_group_list_event(event) {
                this.save_modifications(event.groups);
            },

            async remove_group(id) {
                this.is_load = true;
                await api.delete('/internal/v1/catalog/products/' + this.product.id + "/modifiers/groups/" + id).then(({data}) => {
                    if (data.status === "operation_success") {
                        this.load_modifications();
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            },


            select_group() {
                EventBus.$emit('groups_filter',{'active' : this.items});
            },

            add_group() {
                EventBus.$emit('group_ext_edit',0);
            },

            async save_modifications(groups) {
                this.is_load = true;
                await api.put('/internal/v1/catalog/products/' + this.product.id + "/modifiers/groups",{
                    'groups' : groups
                }).then(({data}) => {
                    if (data.status === "operation_success") {
                        this.load_modifications();
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            },

            async load_modifications() {
                this.items = [];
                this.is_load = true;

                if(parseInt(this.product.id) > 0) {
                    await api.get('/internal/v1/catalog/products/' + this.product.id + "/modifiers").then(({data}) => {
                        this.is_load = false;
                        if (data.status === "operation_success") {
                            this.items = data.data;
                        }
                    }).catch(({response}) => {
                        this.is_load = false;
                        EventBus.$emit('show_toast', {
                            err: response.data.message, type: "danger",
                            title: response.data.status,
                            position: "b-toaster-top-left"
                        })
                    });
                }
            }
        },

        computed : {

            req_group() {
                return this.items.filter(item => {
                    return item.is_required === true;
                });
            },
            not_req_group() {
                return this.items.filter(item => {
                    return item.is_required === false;
                });
            }
        },
    }
</script>

<style scoped>

</style>
